import React, { useState } from "react";
import { FullScreenDialog } from "../../core/FullScreenDialog";
import { SmartTextField } from "../../core/SmartTextField";
import { useCreateGameTask } from "@seabrookstudios/pitch2table";
import { enqueueSnackbar } from "notistack";
import { sanitiseTaskName, TaskMaxLength } from "@seabrookstudios/pitch2table-core";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const AddTaskDialog = ({ gameId }) => {
  const [taskName, setTaskName] = useState("");

  const onSuccess = () => {
    enqueueSnackbar("Task created successfully", { variant: "success" });
    setTaskName("");
  };
  const onFailure = () => {
    enqueueSnackbar("Failed to create task", { variant: "error" });
  };

  const createTask = useCreateGameTask(gameId, onSuccess, onFailure);

  const handleSave = async () => {
    await createTask.mutateAsync({
      name: taskName.trim(),
    });
  };

  const handleTaskNameChange = (value) => {
    setTaskName(value);
  };

  const canSave = taskName.trim() === "";

  return (
    <FullScreenDialog title="Add New Task" actionText="SAVE" canSave={canSave} onSaveHandler={handleSave}>
      <SmartTextField
        label="Task Name"
        initialValue=""
        onChange={handleTaskNameChange}
        sanitize={sanitiseTaskName}
        maxLength={TaskMaxLength}
        required
        autoFocus
      />
    </FullScreenDialog>
  );
};
